<section class="cut-flower-stock">
  <div class="tabs">
    <button
      type="button"
      class="tab"
      [class.active]="activeTab === 'bouquets'"
      (click)="setTab('bouquets')"
    >
      Csokrok
    </button>
    <button
      type="button"
      class="tab"
      [class.active]="activeTab === 'stock'"
      (click)="setTab('stock')"
    >
      Vágott virág készlet
    </button>
  </div>

  <div *ngIf="activeTab === 'bouquets'" class="tab-panel">
    <div class="panel-header">
      <h2>Kirakati csokrok összetétele</h2>
      <div class="panel-actions">
        <label class="date-picker">
          Dátum
          <input type="date" [value]="selectedDate" (change)="onDateChange($any($event.target).value)" />
        </label>
        <button type="button" (click)="saveBouquets()" [disabled]="loadingBouquets">Mentés</button>
      </div>
    </div>

    <p *ngIf="bouquetMessage" class="message">{{ bouquetMessage }}</p>

    <div class="table-scroll">
      <table class="stock-table">
        <thead>
          <tr>
            <th class="sticky">Termék</th>
            <th *ngFor="let col of bouquetColumns">{{ col }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let product of products">
            <td class="sticky">{{ product.label }}</td>
            <td *ngFor="let col of bouquetColumns">
              <input
                type="number"
                min="0"
                [(ngModel)]="bouquetData[product.key][col]"
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>

  <div *ngIf="activeTab === 'stock'" class="tab-panel">
    <div class="panel-header">
      <h2>Napi vágott virág készlet</h2>
      <div class="panel-actions">
        <label class="date-picker">
          Dátum
          <input type="date" [value]="selectedDate" (change)="onDateChange($any($event.target).value)" />
        </label>
        <button type="button" (click)="saveDaily()" [disabled]="loadingDaily">Mentés</button>
      </div>
    </div>

    <p *ngIf="dailyMessage" class="message">{{ dailyMessage }}</p>

    <div class="table-scroll">
      <table class="stock-table">
        <thead>
          <tr>
            <th class="sticky">Termék</th>
            <th>Nyitó</th>
            <th>Selejt</th>
            <th>Eladott</th>
            <th>Záró</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let product of products">
            <td class="sticky">{{ product.label }}</td>
            <td>
              <input
                type="number"
                min="0"
                [(ngModel)]="dailyData[product.key].opening"
                (ngModelChange)="updateDailyRow(product.key)"
              />
            </td>
            <td>
              <input
                type="number"
                min="0"
                [(ngModel)]="dailyData[product.key].scrap"
                (ngModelChange)="updateDailyRow(product.key)"
              />
            </td>
            <td>
              <input
                type="number"
                min="0"
                [(ngModel)]="dailyData[product.key].sold"
                (ngModelChange)="updateDailyRow(product.key)"
              />
            </td>
            <td class="readonly">{{ dailyData[product.key].closing }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</section>
